import { useCallback } from 'react';
import { toast } from 'react-toastify';

const useNotifications = (onOpen = () => {}, onClose = () => {}) => {
  const onNotificationClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const onNotificationOpen = useCallback(() => {
    onOpen();
  }, [onOpen]);

  const showNotification = useCallback((type = 'info', message, autoClose = 3000) => {
    toast[type](message, {
      position: 'top-right',
      autoClose: autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onOpen: onNotificationOpen,
      onClose: onNotificationClose(type, message),
    });
  }, [onNotificationOpen, onNotificationClose]);

  const showError = (message, autoClose = 10000) => {
    showNotification('error', message, autoClose);
  };

  const showSuccess = (message, autoClose = 3000) => {
    showNotification('success', message, autoClose);
  };

  const showInfo = (message, autoClose = 3000) => {
    showNotification('info', message, autoClose);
  };

  return {
    showError,
    showSuccess,
    showInfo,
  };
};

export default useNotifications;
